import { type GetFlowsV2Query } from '~/graphql/types';

type ActionTypeName =
  GetFlowsV2Query['getFlowsV2']['items'][number]['Actions'][number]['__typename'];

const EMAIL_REQUIRED_ACTIONS: Array<ActionTypeName> = [
  'FlowV2_Action_SendEmail_Plain',
  'FlowV2_Action_SendNotification',
];

const isEmailRequiredAction = (__typename: ActionTypeName) =>
  EMAIL_REQUIRED_ACTIONS.includes(__typename);

export default isEmailRequiredAction;
